import { render, staticRenderFns } from "./Component404.vue?vue&type=template&id=4eeb8954&"
import script from "./Component404.vue?vue&type=script&lang=js&"
export * from "./Component404.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports